import axios from 'axios';

 
const API_BASEURL = process.env.REACT_APP_BASE_URL;
console.log('API_BASEURL: ', API_BASEURL);
const instance = axios.create({
  baseURL: API_BASEURL,
  timeout: 15000,
});

instance.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default instance;
